import { SelectField } from "$components/inputs";
import type { InsuranceProvider } from "$routes/new/patient/step3/_lib/insurance/types";
import type { PatientDetailsQuery } from "$routes/patient/[:patientId]/_lib/__generated__/patient-queries.gql";
import { getInitialValues } from "$routes/patient/[:patientId]/_lib/insurance-form-helpers";
import { Box } from "@material-ui/core";
import React, { useMemo } from "react";
import { InsurerSection } from "./insurer-section";

export const InsuranceForm = ({
  insuranceProviders,
  patient,
  setOpen,
}: {
  insuranceProviders: InsuranceProvider[];
  patient: PatientDetailsQuery["patientByCardId"];
  setOpen: (open: boolean) => void;
}) => {
  const initialValues = useMemo(
    () => getInitialValues(patient.patient),
    [patient.patient],
  );
  const [insurerId, setInsurerId] = React.useState(
    patient?.patient?.insurance?.insuranceProvider?.name ?? "",
  );

  return (
    <Box>
      <SelectField
        name="insurer"
        label="Insurer"
        fullWidth
        onChange={(e) => setInsurerId(e.target.value as string)}
        data-testid="sidebar-dropdown"
        options={insuranceProviders.map((provider) => ({
          label: provider.name,
          value: provider.id,
        }))}
        value={insurerId}
      />
      <InsurerSection
        insurerId={insurerId}
        insuranceProviders={insuranceProviders}
        patient={patient}
        setOpen={setOpen}
        initialValues={initialValues}
      />
    </Box>
  );
};
